import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetailViewFeatureParams } from 'src/app/component/detail-view/detail-view.model';
import { IdentifyService } from '../../shared/service/identify.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { WorkspaceNotifyService } from '../../component/header-panel/arbeitsbereich/workspace-notify.service';
import { MainMapService } from '../../shared/service/main-map.service';
import { UrlStateHelperService } from '../../shared/service/url-state/url-state-helper.service';
import { ArbeitsbereichService } from '../../shared/service/arbeitsbereich.service';
import Enums from '../../shared/enum/enums';
import Workspace = Enums.Workspace;
import { ConfigService } from '../../config/config.service';
import { LayerQueryService } from '../../shared/service/layer-query.service';
import { TakeUntilDestroy } from '../../core/component/take-until-destroy';
import { EsriReactiveUtils } from '../../config/esri.module';
import {SelectionService} from "../../shared/service/selection.service";

@Component({
    selector: 'info',
    templateUrl: 'edit-info.component.html',
    styleUrls: ['edit-info.component.scss'],
    standalone: false
})
export class EditInfoComponent extends TakeUntilDestroy implements OnInit, OnDestroy {
  featureParams: DetailViewFeatureParams;

  constructor(
    private route: ActivatedRoute,
    private identifyService: IdentifyService,
    private workspaceNotifyService: WorkspaceNotifyService,
    private urlStateHelperService: UrlStateHelperService,
    private mainMapService: MainMapService,
    private arbeitsbereichService: ArbeitsbereichService,
    private configService: ConfigService,
    private layerQueryService: LayerQueryService,
    private selectionService: SelectionService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnInit() {
    this.route.data
      .pipe(
        switchMap((data: { featureParams: any }) => {
          const featureParams = data.featureParams;
          if (!featureParams) {
            this.urlStateHelperService.setState({
              workspace: this.arbeitsbereichService.selectedArbeitsbereich.id as Workspace,
            });
            return [];
          }
          if (featureParams.changedWorkspace) {
            this.onChangeWorkspace(data.featureParams);
          } else {
            setTimeout(() => {
              if (this.mainMapService.mapView.ready) {
                this.identifyService.sendResultToDetailView(data.featureParams);
              }
              EsriReactiveUtils.when(
                () => this.mainMapService.mapView.ready === true,
                () => {
                  this.identifyService.sendResultToDetailView(data.featureParams);
                  if (data.featureParams.feature.geometry) {
                    this.selectionService.zoomOnFeature(data.featureParams.feature);
                  } else {
                    this.queryGeometryAndZommToFeature(featureParams);
                  }
                }
              );
            }, 0);
            return [];
          }
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  private onChangeWorkspace(data: { featureParams: DetailViewFeatureParams }) {
    return this.workspaceNotifyService.onWorkspaceChangedCompleted.pipe(
      switchMap(() => {
        setTimeout(() => {
          this.identifyService.sendResultToDetailView(data.featureParams);
        }, 0);
        this.cdr.detectChanges();
        return [];
      })
    );
  }

  private queryGeometryAndZommToFeature(featureParams: DetailViewFeatureParams): void {
    const mapServer = this.configService.getLayerUrl(featureParams.mapServerId);
    const mapServerUrl = `${mapServer}/${featureParams.layerId}`;
    this.layerQueryService
      .query(
        mapServerUrl,
        `GLOBALID='${featureParams.feature.attributes.GLOBALID}'`,
        ['globalid'],
        ['globalid'],
        true
      )
      .subscribe(
        response => {
          if (!response.features || response.features.length === 0) {
            console.log('No feature found for the given GlobalID');
            return;
          }
          this.selectionService.zoomOnFeature(response.features[0]);
        },
        error => console.error('Error querying feature', error)
      );
  }
}
